const firebaseConfig = {
  apiKey: "AIzaSyCK4wgCufuVNnKSJerdEwaJ7rQty_-LZMY",
  authDomain: "aventoura-3f2f4.firebaseapp.com",
  projectId: "aventoura-3f2f4",
  storageBucket: "aventoura-3f2f4.appspot.com",
  messagingSenderId: "722286299264",
  appId: "1:722286299264:web:045ed35d7fb9cdbb207e65",
};

export default firebaseConfig;
